var _a, _b, _c, _d;
import { generateActions } from "../generators/generator.actions";
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./task.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["GetTaskComments"] = "GET_TASK_COMMENTS";
    EActionCustom["AddTaskComment"] = "ADD_TASK_COMMENT";
    EActionCustom["DeleteTaskComment"] = "DELETE_TASK_COMMENT";
    EActionCustom["SetShowLimit"] = "SET_SHOW_LIMIT";
})(EActionCustom || (EActionCustom = {}));
var generateGetTaskCommentsActions = function () { return ({
    getTaskCommentsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetTaskComments,
        state: EActionState.Start,
    }),
    getTaskCommentsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetTaskComments,
        state: EActionState.Success,
    }),
    getTaskCommentsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetTaskComments,
        state: EActionState.Fail,
    }),
}); };
var generateAddTaskCommentActions = function () { return ({
    addTaskCommentStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddTaskComment,
        state: EActionState.Start,
    }),
    addTaskCommentSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddTaskComment,
        state: EActionState.Success,
    }),
    addTaskCommentFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddTaskComment,
        state: EActionState.Fail,
    }),
}); };
var generateDeleteTaskCommentActions = function () { return ({
    deleteTaskCommentStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.DeleteTaskComment,
        state: EActionState.Start,
    }),
    deleteTaskCommentSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.DeleteTaskComment,
        state: EActionState.Success,
    }),
    deleteTaskCommentFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.DeleteTaskComment,
        state: EActionState.Fail,
    }),
}); };
var generateCommentSetShowLimitActions = function () { return ({
    commentSetShowLimitStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetShowLimit,
        state: EActionState.Start,
    }),
}); };
export var getTaskCommentsStart = (_a = generateGetTaskCommentsActions(), _a.getTaskCommentsStart), getTaskCommentsSucceeded = _a.getTaskCommentsSucceeded, getTaskCommentsFailed = _a.getTaskCommentsFailed;
export var addTaskCommentStart = (_b = generateAddTaskCommentActions(), _b.addTaskCommentStart), addTaskCommentSucceeded = _b.addTaskCommentSucceeded, addTaskCommentFailed = _b.addTaskCommentFailed;
export var deleteTaskCommentStart = (_c = generateDeleteTaskCommentActions(), _c.deleteTaskCommentStart), deleteTaskCommentSucceeded = _c.deleteTaskCommentSucceeded, deleteTaskCommentFailed = _c.deleteTaskCommentFailed;
export var commentSetShowLimitStart = generateCommentSetShowLimitActions().commentSetShowLimitStart;
export var getDetailStart = (_d = generateActions(GENERATOR_PARAMS), _d.getDetailStart), getDetailSucceeded = _d.getDetailSucceeded, getDetailFailed = _d.getDetailFailed, getPagedStart = _d.getPagedStart, getPagedFailed = _d.getPagedFailed, getPagedSucceeded = _d.getPagedSucceeded, 
// getInfiniteLoadStart,
// getInfiniteLoadFailed,
// getInfiniteLoadSucceeded,
getCountStart = _d.getCountStart, getCountFailed = _d.getCountFailed, getCountSucceeded = _d.getCountSucceeded, createStart = _d.createStart, createSucceeded = _d.createSucceeded, createFailed = _d.createFailed, updateStart = _d.updateStart, updateSucceeded = _d.updateSucceeded, updateFailed = _d.updateFailed, updateMembersStart = _d.updateMembersStart, updateMembersFailed = _d.updateMembersFailed, updateMembersSucceeded = _d.updateMembersSucceeded, removeStart = _d.removeStart, removeSucceeded = _d.removeSucceeded, removeFailed = _d.removeFailed, archiveStart = _d.archiveStart, archiveSucceeded = _d.archiveSucceeded, archiveFailed = _d.archiveFailed, unarchiveStart = _d.unarchiveStart, unarchiveSucceeded = _d.unarchiveSucceeded, unarchiveFailed = _d.unarchiveFailed;
